import { BotLabel } from '@/domain/bot';
import { BotMappie } from '@/domain/bot-mappie';

export function isSmsBot(id: string, bots: BotMappie[] | undefined) {
    const bot = bots?.find((bot) => bot.id == id);
    return bot?.current_bot_version.channel === 'sms';
}

export const isChatBot = (labels: BotLabel[]) =>
    labels.some((l) => l.name === 'chatbot');

export type BotKind = 'sms' | 'chatbot' | 'inbound' | 'outbound';

export const getBotKind = (bot: BotMappie): BotKind => {
    if (bot.current_bot_version?.channel === 'sms') return 'sms';
    if (bot.labels?.some((l) => l.name === 'chatbot')) return 'chatbot';
    if (bot.labels?.some((l) => l.name === 'inbound')) return 'inbound';
    return 'outbound';
};
